import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="page-container">
          <div className="page-content center-content" style={{ maxWidth: '700px' }}>
            <div style={{ fontSize: '5rem', marginBottom: '1rem' }}>
              ⚠️
            </div>
            
            <h1 style={{ 
              fontSize: '2.5rem',
              marginBottom: '1rem',
              color: 'var(--error-red)'
            }}>
              Oops! Something went wrong
            </h1>
            
            <p style={{ 
              fontSize: '1.22rem',
              marginBottom: '2rem',
              color: 'var(--text-medium)'
            }}>
              We encountered an unexpected error. Please try refreshing the page.
            </p>
            
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <div className="alert alert-error" style={{ 
                textAlign: 'left',
                fontSize: '0.95rem',
                fontFamily: 'monospace'
              }}>
                <strong>Error Details:</strong>
                <pre style={{ marginTop: '0.5rem', overflow: 'auto' }}>
                  {this.state.error.toString()}
                </pre>
              </div>
            )}
            
            <button
              className="btn btn-teal"
              onClick={() => window.location.href = '/'}
              style={{
                fontSize: '1.33rem',
                padding: '1.5rem 3rem'
              }}
            >
              Go Back Home
            </button>
            
            <p className="footer-text" style={{ marginTop: '3rem' }}>
              This document is the property of The Sizzleisland Company Limited © 2025
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

